import { EmployeeStatus } from "../enums/employee-status.enum";
import { IHasEmployeeStatus } from "../models/domain/interface/hasEmployeeStatus.interface";
import { Employee } from "../models/employee.model";
import { State } from "../models/state.model";
import { UserProfile } from "../models/user-profile.model";

export abstract class EmployeeHelper {

    public static getDisplayName(employee: Employee): string {
        let idText = '';
        if (employee.employeeIdentifier)
            idText = employee.employeeIdentifier;
        else if (employee.email)
            idText = employee.email;
        else if (employee.userName)
            idText = employee.userName;

        return `${employee.name} (${idText}) `;
    }

    public static getUserProfileDisplayName(userProfile: UserProfile): string {
        let idText = '';
        if (userProfile.employee?.employeeIdentifier)
            idText = userProfile.employee.employeeIdentifier;
        else if (userProfile.email)
            idText = userProfile.email;
        else if (userProfile.userName)
            idText = userProfile.userName;

        return `${userProfile.employee?.name ?? (userProfile.email ?? userProfile.userName)} (${idText}) `;
    }

    public static isEmployeeInactive(employeeData: IHasEmployeeStatus): boolean {
        return employeeData?.employeeStatus === EmployeeStatus.Inactive;
    }

    public static isSelf(employeeId: number, state: State): boolean {
        return state?.me.value?.employee?.id === employeeId;
    }
}